import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { getChallenge } from "@/lib/api";

export default function HumanCheck({ value, onChange, refreshKey }) {
  const [question, setQuestion] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const c = await getChallenge();
      setQuestion(c.question);
      onChange({ challenge_id: c.challenge_id, challenge_answer: "" });
    } catch {
      setQuestion("Verification unavailable");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  return (
    <div>
      <label className="block text-xs tracking-accent uppercase text-zinc-500 mb-2">Human check</label>
      <div className="flex items-center gap-3">
        <span data-testid="human-check-question" className="text-sm text-zinc-300 min-w-[110px]">
          {loading ? "Loading…" : question}
        </span>
        <input
          data-testid="human-check-answer"
          type="number"
          required
          value={value?.challenge_answer ?? ""}
          onChange={(e) => onChange({ ...value, challenge_answer: e.target.value })}
          className="w-24 bg-zinc-900 border border-zinc-700 px-3 py-2 text-sm text-zinc-100 focus:outline-none focus:ring-1 focus:ring-amber-500"
          placeholder="?"
        />
        <button type="button" onClick={load} data-testid="human-check-refresh" className="text-zinc-500 hover:text-amber-500 transition-colors" aria-label="New question">
          <RefreshCw size={16} />
        </button>
      </div>
    </div>
  );
}
